function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Story-editor-open-pages",
  transform: "translate(-1651.000000, -1046.000000)",
  fill: "#FF6425"
}, React.createElement("path", {
  d: "M1670.11688,1049.90396 L1670.09604,1049.88312 C1669.63132,1049.4184 1668.87785,1049.4184 1668.41313,1049.88312 L1662.5,1055.79625 L1656.58687,1049.88312 C1656.12215,1049.4184 1655.36868,1049.4184 1654.90396,1049.88312 L1654.88312,1049.90396 C1654.4184,1050.36868 1654.4184,1051.12215 1654.88312,1051.58687 L1660.79625,1057.5 L1654.88312,1063.41313 C1654.4184,1063.87785 1654.4184,1064.63132 1654.88312,1065.09604 L1654.90396,1065.11688 C1655.36868,1065.5816 1656.12215,1065.5816 1656.58687,1065.11688 L1662.5,1059.20375 L1668.41313,1065.11688 C1668.87785,1065.5816 1669.63132,1065.5816 1670.09604,1065.11688 L1670.11688,1065.09604 C1670.5816,1064.63132 1670.5816,1063.87785 1670.11688,1063.41313 L1664.20375,1057.5 L1670.11688,1051.58687 C1670.5816,1051.12215 1670.5816,1050.36868 1670.11688,1049.90396 Z",
  id: "add-page",
  transform: "translate(1662.500000, 1057.500000) rotate(45.000000) translate(-1662.500000, -1057.500000) "
})));

var SvgAddPage = function SvgAddPage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_page.d68e1e05.svg";
export { ForwardRef as ReactComponent };